(function (root) {
  'use strict';

  var KIME_ILGI = {
    mom: ['beauty-personal-care-2', 'home-kitchen', 'fashion-jewelry', 'health-wellness'],
    dad: ['automotive', 'electronics', 'home-kitchen', 'office-school'],
    partner: ['beauty-personal-care-2', 'fashion-jewelry', 'electronics', 'home-kitchen'],
    friend: ['home-kitchen', 'electronics', 'musical-instruments', 'books'],
    kids: ['video-games-toys', 'baby', 'books'],
    pet: ['pet-supplies-1'],
    myself: ['pet-supplies-1', 'beauty-personal-care-2', 'home-kitchen', 'electronics']
  };

  var BUTCE_ARALIGI = {
    'under-25': { min: 0, max: 2499 },
    '25-50': { min: 2500, max: 4999 },
    '50-100': { min: 5000, max: 9999 },
    '100-plus': { min: 10000, max: Infinity }
  };

  function ilgiAlanlari(kime) {
    return (KIME_ILGI[kime] || []).slice();
  }

  function butceAraligi(kod) {
    var r = BUTCE_ARALIGI[kod];
    if (!r) { return null; }
    return { min: r.min, max: r.max };
  }

  function kartlariSuz(kartlar, min, max) {
    if (!kartlar || typeof kartlar.length !== 'number') { return []; }
    var lo = (typeof min === 'number') ? min : 0;
    var hi = (typeof max === 'number') ? max : Infinity;
    var out = [];
    for (var i = 0; i < kartlar.length; i++) {
      var card = kartlar[i];
      var p = Number(card && card.price);
      if (!isFinite(p)) { continue; }
      if (p >= lo && p <= hi) { out.push(card); }
    }
    return out;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  var api = {
    ilgiAlanlari: ilgiAlanlari,
    butceAraligi: butceAraligi,
    kartlariSuz: kartlariSuz,
    escapeHtml: escapeHtml
  };

  root.STHGiftFinder = api;
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (typeof document === 'undefined') { return; }

  function readConfig() {
    var el = document.getElementById('sth-gf-config');
    if (!el) { return null; }
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function init() {
    var host = document.getElementById('sth-gift-finder');
    var cfg = readConfig();
    if (!host || !cfg) { return; }

    var labels = cfg.labels || {};
    var collLabels = cfg.collections || {};
    var rootUrl = cfg.rootUrl || '/';
    if (rootUrl.charAt(rootUrl.length - 1) !== '/') { rootUrl += '/'; }
    var MAX_CARDS = 12;

    var state = { kime: '', ilgi: '', butce: '' };
    var step = 1;

    var stepEls = host.querySelectorAll('[data-sth-gf-step]');
    var dotEls = host.querySelectorAll('[data-sth-dot]');
    var backBtn = host.querySelector('[data-sth-action="back"]');
    var restartBtn = host.querySelector('[data-sth-action="restart"]');
    var interestsBox = host.querySelector('[data-sth-interests]');
    var resultsBox = host.querySelector('[data-sth-results]');
    var summaryEl = host.querySelector('[data-sth-summary]');

    function showStep(n) {
      step = n;
      for (var i = 0; i < stepEls.length; i++) {
        var v = stepEls[i].getAttribute('data-sth-gf-step');
        stepEls[i].hidden = (String(v) !== String(n));
      }
      var shown = Math.min(n, 3);
      for (var d = 0; d < dotEls.length; d++) {
        var on = Number(dotEls[d].getAttribute('data-sth-dot')) <= shown;
        dotEls[d].setAttribute('data-on', on ? '1' : '0');
      }
      if (backBtn) { backBtn.hidden = (n <= 1); }
      if (restartBtn) { restartBtn.hidden = (n <= 1); }
    }

    function renderInterests(kime) {
      if (!interestsBox) { return; }
      interestsBox.textContent = '';
      var handles = ilgiAlanlari(kime);
      for (var i = 0; i < handles.length; i++) {
        var h = handles[i];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sth-gf-btn';
        b.setAttribute('data-sth-interest', h);
        b.textContent = collLabels[h] || h;
        interestsBox.appendChild(b);
      }
    }

    function collectionUrl(handle) {
      return rootUrl + 'collections/' + handle;
    }

    function sectionUrl(handle, lo, hi) {
      var url = collectionUrl(handle) + '?section_id=sth-gift-results' + '&sort_by=best-selling';
      if (typeof lo === 'number' && isFinite(lo)) { url += '&filter.v.price.gte=' + (lo / 100).toFixed(2); }
      if (typeof hi === 'number' && isFinite(hi)) { url += '&filter.v.price.lte=' + (hi / 100).toFixed(2); }
      return url;
    }

    function showSeeAll(handle, prefix) {
      if (!resultsBox) { return; }
      resultsBox.innerHTML = '<p class="sth-gf-muted sth-gf-more">' + escapeHtml(prefix || '') +
        ' <a class="sth-gf-link" href="' + escapeHtml(collectionUrl(handle)) + '">' +
        escapeHtml(collLabels[handle] || handle) + '</a></p>';
    }

    function appendSeeAll(handle) {
      var p = document.createElement('p');
      p.className = 'sth-gf-muted sth-gf-more';
      var a = document.createElement('a');
      a.className = 'sth-gf-link';
      a.href = collectionUrl(handle);
      a.textContent = (labels.seeAll || '') + (collLabels[handle] || handle);
      p.appendChild(a);
      resultsBox.appendChild(p);
    }

    function renderCards(handle, cards, lo, hi) {
      if (!resultsBox) { return; }
      var kept = kartlariSuz(cards, lo, hi).slice(0, MAX_CARDS);
      resultsBox.textContent = '';
      if (!kept.length) { showSeeAll(handle, labels.noResults); return; }
      for (var i = 0; i < kept.length; i++) { resultsBox.appendChild(kept[i].el); }
      appendSeeAll(handle);
    }

    function loadResults() {
      var handle = state.ilgi;
      var range = butceAraligi(state.butce) || { min: 0, max: Infinity };
      if (summaryEl) { summaryEl.textContent = collLabels[handle] || handle; }
      if (resultsBox) {
        resultsBox.innerHTML = '<p class="sth-gf-muted sth-gf-more">' + escapeHtml(labels.loading || '') + '</p>';
      }
      var done = false;
      function fail() {
        if (done) { return; }
        done = true;
        showSeeAll(handle, labels.error);
      }
      var url = sectionUrl(handle, range.min, range.max);
      try {
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (res) {
            if (!res.ok) { throw new Error('request failed'); }
            return res.text();
          })
          .then(function (html) {
            if (done) { return; }
            done = true;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nodes = doc.querySelectorAll('.sth-gf-card');
            var cards = [];
            for (var i = 0; i < nodes.length; i++) {
              cards.push({ el: nodes[i], price: Number(nodes[i].getAttribute('data-price')) });
            }
            renderCards(handle, cards, range.min, range.max);
          })
          .catch(fail);
      } catch (e) {
        fail();
      }
    }

    host.addEventListener('click', function (ev) {
      var t = ev.target;
      var btn = (t && t.closest) ? t.closest('button') : null;
      if (!btn) { return; }
      var recipient = btn.getAttribute('data-sth-recipient');
      var interest = btn.getAttribute('data-sth-interest');
      var budget = btn.getAttribute('data-sth-budget');
      var action = btn.getAttribute('data-sth-action');
      if (recipient) { state.kime = recipient; state.ilgi = ''; renderInterests(recipient); showStep(2); return; }
      if (interest) { state.ilgi = interest; showStep(3); return; }
      if (budget) { state.butce = budget; showStep(4); loadResults(); return; }
      if (action === 'back') { showStep(Math.max(1, step - 1)); return; }
      if (action === 'restart') { state = { kime: '', ilgi: '', butce: '' }; showStep(1); return; }
    });

    showStep(1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(typeof window !== 'undefined' ? window : this);
